import axios from "axios";
import { Nullable } from "primereact/ts-helpers";
import { useEffect, useState } from "react";
import { Location, Room } from "./models/Models";
import SearchBar from "./SearchBar/SearchBar";
// import DateRange from "./DateRange/DateRange";
import RoomPax from "./RoomPax/RoomPax";
import { Button } from "primereact/button";
import { useLocation } from "react-router-dom";
import DateRange from "./DateRange/DateRange";

function AutoSuggest() {
    const queryParams = new URLSearchParams(useLocation().search);
    const emptyRoom: Room = { numOfAdults: 2, numOfChildren: 0, childAges: [] };
    const [dates, setDates] = useState<Nullable<(Date | null)[]>>(null);
    const [rooms, setRooms] = useState<Room[]>([emptyRoom]);
    const apiKey: string = process.env.REACT_APP_API_KEY || '';
    const [isSearchEnabled, setIsSearchEnabled] = useState<boolean>(false);
    const [isValid, setIsValid] = useState<boolean>(false);
    const [autoSuggestUrl, setAutoSuggestUrl] = useState<string>('');
    const [theme, setTheme] = useState<any>(null);
    const [userSessionKey] = useState<string>(() =>
        (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `${new Date().getTime()}`
    );

    const [searchBarResult, setSearchBarResult] = useState<Location>({
        coordinates: {
            lat: 0,
            long: 0,
        },
        country: "",
        fullName: "",
        id: 0,
        name: "",
        score: 0,
        type: "",
    });

    const [locationsData, setLocationsData] = useState<Location[]>([]);
    const [redirectUrl, setRedirectUrl] = useState<string>(queryParams.get('redirecturl') || "");

    const stringToDateTranslator = (dateStr: string): Date=>{
        let date = new Date();
        date.setFullYear(parseInt(dateStr.substring(0, 4)));
        date.setMonth(parseInt(dateStr.substring(4, 6))-1); // MONTH IS 0 INDEXED
        date.setDate(parseInt(dateStr.substring(6, 8)));
        return date;
    }

    const dateToStringTranslator = (date: Date): string=>{
        let stringDate: string = `${date.getFullYear()}`;
        if(date.getMonth() < 9){
            stringDate += "0"; 
        }
        stringDate += `${date.getMonth()+1}`; // MONTH IS 0 INDEXED IN JS
        if(date.getDate() < 10){
            stringDate += "0";
        }
        stringDate += date.getDate();
        
        return (stringDate);
    }

    const stringToRoomsTranslator = (roomString: string): Room[] => {
        return roomString.split('_').map(room => {
            const [adults, children] = room.split('-');
            const numOfAdults = parseInt(adults);
            let childAges: number[] = [];
            let numOfChildren: number = 0;
            children?.split(':').forEach((child, index)=>{
                if(index === 0)
                    numOfChildren = parseInt(child);
                else childAges.push(parseInt(child));
            })
            return {
                numOfAdults: numOfAdults,
                numOfChildren: numOfChildren,
                childAges: childAges
            };
        });
    }

    const roomsToStringTranslator = (rooms: Room[]): string => {
        return rooms.map(room => {
            const adultsPart = room.numOfAdults.toString();
            const childrenPart = [room.numOfChildren.toString(), ...room.childAges.map(age => age.toString())].join(':');
            return room.numOfChildren > 0 ? `${adultsPart}-${childrenPart}` : adultsPart;
        }).join('_');
    }

    const getInputsFromParams = ()=>{
        let redirect = queryParams.get("redirecturl");
        let checkinDate = queryParams.get("checkin");
        let checkoutDate = queryParams.get("checkout");
        let locationId = queryParams.get("locationid");
        let name = queryParams.get("name");
        let roomPax = queryParams.get("roompax");
        let primaryColor = queryParams.get("primarycolor") || "rgb(124, 67, 189)";
        let primaryColorContrast = queryParams.get("primarycolorcontrast") || "#512a6a";
        let primaryColorTint = queryParams.get("primarycolortint") || "#faf3ff";
        let secondaryColor = queryParams.get("secondarycolor");
        if(checkinDate && checkoutDate){
            let dateArr: Date[] = [];
            dateArr[0] = stringToDateTranslator(checkinDate);
            dateArr[1] = stringToDateTranslator(checkoutDate);
            setDates(dateArr);
        }
        if(locationId){
            let tempSearchBarRs = searchBarResult;
            tempSearchBarRs.id = parseInt(locationId);
            setSearchBarResult(tempSearchBarRs);
        }
        if(name){
            let tempSearchBarRs = searchBarResult;
            tempSearchBarRs.fullName = name;
            setSearchBarResult(tempSearchBarRs);
            
        }
        if(roomPax){
            console.log("roomPax");
            let tempRoomPax: Room[] = stringToRoomsTranslator(roomPax);
            setRooms(tempRoomPax);
        }

        if(redirect){
            setRedirectUrl(redirect);
        }

        if(primaryColorTint){

        }

        if(secondaryColor){
            document.documentElement.style.setProperty('--secondary-color', secondaryColor);
        }

        document.documentElement.style.setProperty('--primary-color', primaryColor);
        document.documentElement.style.setProperty('--primary-color-contrast', primaryColorContrast);
        document.documentElement.style.setProperty('--primary-color-tint', primaryColorTint);

        // if(primaryColor){
        //     let tmpTheme = theme;
        //     tmpTheme.primaryColor = primaryColor;
        //     setTheme(primaryColor);
        // }

        // if(primaryColorContrast){
        //     let tmpTheme = theme;
        //     tmpTheme.primaryColorContrast = primaryColorContrast;
        //     setTheme(primaryColor);
        // }
        
    }

    const generateRedirectParams = (): string=>{
        // ?checkin=20240815&checkout=20240816&locationid=328605&name=Pune, Maharashtra, India&roompax=2_2-2:3:13
        
        let roomPax = roomsToStringTranslator(rooms);
        //@ts-ignore
        let params = `?checkin=${dateToStringTranslator(dates[0])}&checkout=${dateToStringTranslator(dates[1])}&locationid=${searchBarResult.id}&name=${searchBarResult.fullName}&roompax=${roomPax}`;
        return params;
    }

    // Search init API expects dates as MM/DD/YYYY
    const dateToSlashStringTranslator = (date: Date): string => {
        const month = `${date.getMonth() + 1}`.padStart(2, "0"); // MONTH IS 0 INDEXED IN JS
        const day = `${date.getDate()}`.padStart(2, "0");
        return `${month}/${day}/${date.getFullYear()}`;
    }

    // Calls the search init API and returns the searchId used to build the results URL.
    // Note: init relies on a backend session, so it can fail (500) when the session
    // is cold - callers should fall back to a plain results redirect in that case.
    const initSearch = async (): Promise<string | null> => {
        const initUrl = process.env.REACT_APP_SEARCH_INIT_URL || "";
        if (initUrl === "") {
            console.error("No search init url configured");
            return null;
        }
        if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
            console.error("Check-in / check-out dates missing");
            return null;
        }

        const currency = queryParams.get("currency") || "INR";
        const body = {
            culture: queryParams.get("culture") || "en-us",
            currency: currency,
            checkIn: dateToSlashStringTranslator(dates[0]),
            checkOut: dateToSlashStringTranslator(dates[1]),
            rooms: rooms.map(room => ({
                adults: room.numOfAdults,
                children: room.numOfChildren,
                childAges: room.childAges,
            })),
            countryOfResidence: queryParams.get("countryofresidence") || "US",
            nationality: queryParams.get("nationality") || "US",
            locationId: `${searchBarResult.id}`,
            fullName: searchBarResult.fullName,
        };

        try {
            const resp = await axios.post(initUrl, body, {
                headers: {
                    "content-type": "application/json",
                    "currencycode": currency,
                    "system-ip": "127.0.0.1",
                    "user-session-key": userSessionKey,
                },
                withCredentials: true, // send the .TravelApi.Session cookie (same-site hosting)
            });
            if (resp.status === 200 && resp.data?.searchId) {
                return resp.data.searchId;
            }
            console.warn("search init did not return a searchId", resp.data);
            return null;
        } catch (ex) {
            console.error("search init failed", ex);
            return null;
        }
    }

    const redirect = async ()=>{
        if(redirectUrl === ""){
            console.error("No redirect url found");
            return;
        }

        // Accept a redirecturl that is either the site root or already the results page.
        let base: string = redirectUrl.replace(/\/+$/, "");
        if(!/\/hotels\/results$/.test(base)){
            base += "/hotels/results";
        }

        // Preferred: init the search and deep-link to /hotels/results/{searchId}.
        // Fallback: if init fails (cold session / 500), still send the user to the
        // results page with the criteria so the button never dies - the results
        // page will run its own init.
        const searchId = await initSearch();
        let redirectTo: string = searchId
            ? `${base}/${searchId}${generateRedirectParams()}`
            : `${base}${generateRedirectParams()}`;
        console.log("redirecting to", redirectTo);
        window.open(redirectTo, '_top');
    }

    useEffect(()=>{
        getInputsFromParams();
    }, [])

    useEffect(()=>{
        if(apiKey === '' || apiKey === undefined || apiKey === null || redirectUrl === '' || redirectUrl === undefined || redirectUrl === null){
            setAutoSuggestUrl("");
            setIsSearchEnabled(false);
        }
        else{
            // APIKEY VALIDATION LOGIC TO-DO
            setAutoSuggestUrl(process.env.REACT_APP_AUTOSUGGEST_URL || '');
            setIsSearchEnabled(true);
        } 
    }, [apiKey, redirectUrl])

    useEffect(()=>{
        if(searchBarResult.id && dates?.length === 2){
            setIsValid(true);
        }
        else{
            setIsValid(false);
        }
    }, [searchBarResult, dates])

    return ( 
        <>
            <div>
                <div className="grid justify-content-center p-3">
                    <div className="sm:col-12 lg:col-5 xl:col-5 col-12">
                        <SearchBar isSearchEnabled={isSearchEnabled} autoSuggestUrl={autoSuggestUrl} locationsData={locationsData} searchBarResult={searchBarResult} setLocationsData={setLocationsData} setSearchBarResult={setSearchBarResult}></SearchBar>
                    </div>
                    <div className="sm:col-12 lg:col-3 xl:col-3 col-12">
                        <DateRange dates={dates} setDates={setDates}></DateRange>
                        {/* <div className="m-1 text-center">
                            <RDateRange></RDateRange>
                        </div> */}
                    </div>
                    <div className="sm:col-12 lg:col-3 xl:col-3 col-12">
                        <RoomPax rooms={rooms} setRooms={setRooms}></RoomPax>
                    </div>
                    <div className="sm:col-12 lg:col-1 xl:col-1 my-1 col-12">
                        <Button disabled={!(isSearchEnabled && isValid)} onClick={redirect} label="Search" style={{width: "100%"}}></Button>
                    </div>
                </div>
            </div>
        </>
     );
}

export default AutoSuggest;